import { Loader2 } from "lucide-react";

export function Card({ children, className = "", gold = false, ...rest }) {
  return (
    <div className={`bg-bb-surface border ${gold ? "border-bb-gold/22" : "border-bb-line"} rounded ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function Spinner({ label }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 py-2">
      {[0, 1, 2].map((i) => (
        <div key={i} className="h-24 rounded border border-bb-line bb-shimmer" />
      ))}
    </div>
  );
}

export function PageHeader({ category = "Virtus Diamond Registry", title, subtitle, updated, right }) {
  return (
    <div className="mb-7">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-[0.7rem] uppercase tracking-[0.18em] text-bb-gold mb-2">{category}</div>
          <h1 className="font-serif text-[2rem] sm:text-[2.25rem] leading-none text-bb-text font-semibold" style={{ letterSpacing: "-0.02em" }}>{title}</h1>
          {subtitle && <p className="text-bb-secondary text-sm mt-2 max-w-2xl">{subtitle}</p>}
          {updated && <div className="text-[0.75rem] text-bb-dim mt-2 tnum">{updated}</div>}
        </div>
        {right}
      </div>
      <div className="h-px bg-bb-gold/20 mt-5" />
    </div>
  );
}

export function Delta({ value, suffix = "%", invert = false }) {
  if (value == null) return <span className="text-bb-dim text-xs tnum">- {suffix}</span>;
  const color = value === 0 ? "#9C9189" : value > 0 ? "#4A7C59" : "#8B3A3A";
  const arrow = value > 0 ? "▲" : value < 0 ? "▼" : "-";
  return (
    <span className="inline-flex items-center gap-1 text-xs tnum" style={{ color }}>
      {arrow} {Math.abs(value)}{suffix}
    </span>
  );
}

export function StatPill({ label, value, hint }) {
  return (
    <div className="px-4 py-3 rounded border border-bb-line bg-bb-surface">
      <div className="text-[0.7rem] uppercase tracking-[0.12em] text-bb-secondary">{label}</div>
      <div className="font-serif text-2xl text-bb-gold tnum mt-1 leading-none">{value}</div>
      {hint && <div className="text-[11px] text-bb-dim tnum mt-1.5">{hint}</div>}
    </div>
  );
}

export function Divider({ label }) {
  if (label) {
    return <div className="text-[0.65rem] uppercase tracking-[0.2em] text-bb-dim my-6">{label}</div>;
  }
  return <div className="bb-divider my-8"><span>◆</span></div>;
}

export function EmptyState({ children = "No data for this period" }) {
  return <div className="font-serif italic text-[1.1rem] text-bb-secondary text-center py-12">{children}</div>;
}

export function DataDisclaimer() {
  return (
    <div className="mt-8 rounded border border-bb-gold/20 bg-bb-surface p-5" data-testid="data-disclaimer">
      <div className="text-[0.7rem] uppercase tracking-[0.18em] text-bb-gold mb-2">About This Data</div>
      <p className="text-bb-secondary text-xs leading-relaxed max-w-3xl">
        Figures shown are <span className="text-bb-gold">VDR data</span>, proprietary composite series produced
        in-house by the VDR research desks and computed by the registry's pricing engine.{" "}
        <a href="/methodology" className="text-bb-gold hover:underline">See our data standards →</a>
      </p>
    </div>
  );
}

export function money(n, dp = 0) {
  if (n == null) return "-";
  return "$" + Number(n).toLocaleString(undefined, { minimumFractionDigits: dp, maximumFractionDigits: dp });
}
